document.addEventListener("DOMContentLoaded", function () {
  const timeFilter = document.getElementById("filter_time");
  const skillFilter = document.querySelector(".Skill select");
  const clearFilter = document.querySelector(".clear-fliter-text");
  const projectCards = document.querySelectorAll(".box_main");
  const noProductMessage = document.querySelector(".no_product");

  // Function to filter projects based on the selected filters
  function filterProjects() {
    const selectedTime = timeFilter.value;
    const selectedSkill = skillFilter.value;
    let filtered = false;

    // Check if filters are applied
    if (selectedTime === "Time" && selectedSkill === "Skill") {
      clearFilter.classList.add("hide-clear");
    } else {
      clearFilter.classList.remove("hide-clear");
    }

    projectCards.forEach((card) => {
      const cardTime = card.classList.contains(`filter_${selectedTime.split(" ")[0]}`);
      
      const cardSkill = card.classList.contains(`filter_${selectedSkill}`);
      const matchesTime = selectedTime === "Time" || cardTime;
      const matchesSkill = selectedSkill === "Skill" || cardSkill;

      if (matchesTime && matchesSkill) {
        card.classList.remove("hide-project");
        filtered = true;
      } else {
        card.classList.add("hide-project");
      }
    });

    if (!filtered) {
      noProductMessage.classList.remove("hide-error-message");
    } else {
      noProductMessage.classList.add("hide-error-message");
    }
  }

  // Function to reset filters to default state
  function resetFilters() {
    timeFilter.value = "Time"; // Reset time filter
    skillFilter.value = "Skill"; // Reset skill filter
    clearFilter.classList.add("hide-clear"); // Hide the clear filter button
    noProductMessage.classList.add("hide-error-message"); // Hide no product message

    // Show all cards by default
    projectCards.forEach((card) => {
      card.classList.remove("hide-project");
    });
  }

  // Event listeners
  timeFilter.addEventListener("change", filterProjects);
  skillFilter.addEventListener("change", filterProjects);

  clearFilter.addEventListener("click", resetFilters);

  // Reset filters every time the page loads
  resetFilters();
});
